<template>
  <div class="newslist">
    <img src="/assets/imgs/newsList.png" class="title-2 unselectable" alt="" style="height: 66px;" />
    <div class="news-line font-xbs"></div>
    <div class="news-count" v-if="newsCount">
      <div class="item">案例总数量：{{ newsCount.news_count }}</div>
      <div class="item">金牌案例数量：{{ newsCount.gold_news_count }}</div>
    </div>
    <img src="/assets/imgs/arrow.png" class="news-arrow unselectable" alt="" style="height: 20px;" />
    <div class="card-section">
      <div class="card-row" v-for="(item, row) in rownum" :key="item">
        <Newscard v-for="item2 in articleRowNum(row)" :key="item2"
          :article-id="user.pages.home.list[((item) - 1) * 3 + item2 - 1]" />
      </div>
    </div>
    <div class="show-more font-xbs" @click="showMore()" v-if="user.pages.home.total - rownum * 3 > 0">
      展开更多
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import Newscard from "./Newscard.vue"
import { userinfo } from '@/stores/counter'
import getArticleList from '@/api/getArticleList'
import getNewsCount from '@/api/getNewsCount'

const { allList } = getArticleList();
const { getCount } = getNewsCount();
const user = userinfo()
const newsCount = ref()

const rownum = computed(() => {
  return Math.ceil(user.articleNum / 3)
})

function showMore() {
  user.pages.home.page++;
  allList();
}

const articleRowNum = (row: number) => {
  if (user.pages.home.list.length == 0) return 0
  return Math.min(3, user.pages.home.list.length - row * 3)
}

onMounted(async ()=>{
  const data = await getCount()

  newsCount.value = data

})

</script>

<style scoped>
.title-2 {
  position: relative;
  top: 10px;
}

.news-count{
  color: #fb5a52;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 140px;
  width: 100%;
  padding-left: 10px;
  box-sizing: border-box;
}
.news-count .item + .item{
  margin-left: 60px;
}

.news-arrow {
  margin-top: 30px;
}
信息公开提醒
.news-line {
  margin-top: 20px;
  height: 1px;
  background-color: #fbdcbe;
  width: 50%;
}

.newslist {
  padding: 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
}

.card-section {
  width: 100%;
  max-width: 1920px;
  height: max-content;
  /* background-color: aqua; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.card-row {
  width: 100%;
  height: max-content;
  /* background-color: aqua; */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
</style>